import React, { useContext, useMemo } from "react";
import { HelpTipContext } from "../../contexts/HelpTipContext";

const HelpTip = ({ elementName, tooltipText = "?" }) => {
  const { helpTipsList = [], isFetching } = useContext(HelpTipContext);

  const helpTip = helpTipsList.find(
    (x) => x.isActive && x.element_name === elementName
  );

  if (isFetching || !helpTip) return null;

  return (
    <div className="question_icon position-relative tool">
      <span>{tooltipText}</span>

      <div
        id="custom-tooltip"
        className="commit-tooltip hover_description text-left"
      >
        {/* Header */}
        {helpTip.helpTipHeading && (
          <div className="HT_tooltip_header">
            <div className="HT_tooltip_heading">{helpTip.helpTipHeading}</div>
          </div>
        )}

        {/* Description */}
        {helpTip.helpTipDescription && (
          <div className="HT_tooltip_text">{helpTip.helpTipDescription}</div>
        )}

        {/* Links */}
        <div className="link-container">
          {helpTip.helpTip_Link1 && (
            <a
              href={helpTip.helpTip_Link1}
              target="_blank"
              rel="noopener noreferrer"
            >
              {helpTip.helpTip_AliasName1 || "Link 1"}
            </a>
          )}

          {helpTip.helpTip_Link2 && (
            <a
              href={helpTip.helpTip_Link2}
              target="_blank"
              rel="noopener noreferrer"
            >
              {helpTip.helpTip_AliasName2 || "Link 2"}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default HelpTip;
